// import { getSkin } from '@/utils/auth'
// export const setSkin = function () {
//     setTimeout(() => {
//         let skin = getSkin()
//         if (skin == null) {
//             skin = "shallow"
//         }
//         let link = document.createElement("link");
//         link.type = "text/css";
//         link.id = "theme";
//         link.rel = "stylesheet";
//         link.href = `./assets/${skin}.css`;
//         document.getElementsByTagName("head")[0].appendChild(link);
//     }, 100);
// }

import { getSkin } from '@/utils/auth'

export const setSkin = function () {
    setTimeout(() => {
        let skin = getSkin()
        if (skin == null) {
            skin = "shallow"
        }
        
        // 尝试获取已经存在的 theme 标签，避免重复创建
        let link = document.getElementById("theme");
        if (!link) {
            link = document.createElement("link");
            link.id = "theme";
            link.type = "text/css";
            link.rel = "stylesheet";
            document.getElementsByTagName("head")[0].appendChild(link);
        }
        
        // 【关键修改点】：去掉前面的点 . 改成正斜杠 / 
        // 这样无论在哪个页面，都会从服务器根目录加载 CSS
        link.href = `/assets/${skin}.css`; 
        
    }, 100);
}